import type { NavigationGuardWithThis, RouteLocationRaw } from 'vue-router';
import type { FlagKey } from '../registry.ts';
import { readFlagValue } from '../resolve-flag.ts';
import { growthBookRef, growthBookInitPromise } from '../config.ts';

export type FeatureFlagGuardOptions = {
  redirect: RouteLocationRaw;
};

export function featureFlagGuard(
  key: FlagKey,
  { redirect }: FeatureFlagGuardOptions,
): NavigationGuardWithThis<undefined> {
  return async () => {
    if (growthBookInitPromise !== null) {
      await growthBookInitPromise;
    }

    if (!growthBookRef?.value) {
      return redirect;
    }

    const resolved = readFlagValue(key);

    return resolved !== false && resolved !== undefined ? true : redirect;
  };
}
